export default "__VITE_ASSET__CFi7Zyxa__"